import styled from "@emotion/styled";

export const Wrapper = styled.div`
  font-size: ${p => p.theme.fontSizes.m};
  font-weight: ${p => p.theme.fontWeight.medium};
  color: ${p => p.theme.colors.secondary.gray};
`;

export const DesctopWrapper = styled.div`
  display: none;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    display: block;
  }
`;

export const MobileWrapper = styled.div`
  display: flex;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    display: none;
  }
`;
